import React, { Component } from 'react';
import CertRequestModel from "../../models/certrequest";
import  PanelLayout  from "../layout/panel-layout";

import PatientPartial from "../partials/patient";
import CertReqPartial from '../partials/certreq';
import CertReqServicePartial from "../partials/certreqservice";
import CertReqPaymentPartial from "../partials/certreqpayment";
import CertReqDocPartial from '../partials/certreqdocs';
import CertReqFormsPartial from '../partials/certreqforms';
import CertUniqueNoModal from '../modal/certuniquenomodal';
import CertRevokeUniqueNoModal from '../modal/certrevokeuniquenomodal';
import {history} from '../../helpers/history';
import  ToggleableLink  from "../../helpers/toggleableLink";
class CertReqPayment extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           //_model:new CertRequestModel(this.refs),
           model:null,
          // certTypeGroupList:null,
          // certReferenceList:null

          
        };
       
     
        
        
        this.handlebackClick=this.handlebackClick.bind(this);
      
    }

    
    
    handleTextChange(event) {
        this.refreshModel();
    }

  

    componentWillReceiveProps(newProps)
    {
        console.log('newProps***',newProps)
        const {model}=newProps;
        console.log('-model-',model)


        
        
        if(model!=null)
        {

            this.setState({

                model:model,    
            });
           // alert('model updated');
          //  this.forceUpdate();
        }
       
        
    }

    handleClick = (e) => {
        this.props.submitHandler(e);
       
    };

    handlebackClick()
    {
        history.goBack();
    }

    render() { 
        //const {model} = this.props;

        const {model}= this.state;
        const {loading,certTypeGroupList,certTypeList} = this.props;
        //const model=_model;    

        console.log('777model777',model);

        return ( 

        <PanelLayout title={"پرداخت ها"}>
           
            <div className="panel-body custom">
                <div className="panel panel-default">
                
                    <div className="toolbox">

                    <button type="button" disabled ={loading } className="btn btn-default btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ثبت و ادامه
                    
                        { loading &&
                            <i className="fa fa-spinner fa-spin"></i>
                        }

                    </button>
                       
                    </div>
                </div>
            
            <PatientPartial patient={model && model.Patient}></PatientPartial>

            <CertReqPartial model={model}></CertReqPartial>
            <div class="panel panel-default">
                
                <div class="panel-body custom">

                    <CertReqPaymentPartial model={model} {...this.props}></CertReqPaymentPartial>

            
                </div>
            </div>
                
            
           
               
            </div>
        </PanelLayout>





        );
    }
}

 
export default CertReqPayment;